<template>
    <div>
        <el-form style="width: 1500px;" :inline="true" :model="feedForm"  :rules="feedRules"  ref="feedForm" class="demo-form-inline" size="small">
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item  label="日期：" prop="feedDate" style="margin-left: 25px;">
                        <el-date-picker 
                                v-model="feedForm.feedDate"
                                type="date"
                                placeholder=""
                                style="width:140px;"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="車號：" prop="carNumber">
                        <el-input placeholder=""  clearable v-model="feedForm.carNumber" style="width: 100px;">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label-width="100px" label="扎車" prop="title">
                        <el-input placeholder="半卷坑紙 + 1地膠 + 2縐紋紙"  clearable v-model="feedForm.title" style="width: 500px;">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="坑紙"   prop="pitPaper">
                            <el-input placeholder="" v-model="feedForm.pitPaper" clearable style="width: 100px;" @change="validateChange">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="報紙" prop="newsPaper">
                            <el-input placeholder="" v-model="feedForm.newsPaper" clearable style="width: 100px;" @change="validateChange">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="卜卜膠" prop="buBu">
                            <el-input placeholder="" v-model="feedForm.buBu" clearable style="width: 100px;" @change="validateChange">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="拷貝紙" prop="copyPaper">
                            <el-input placeholder="" v-model="feedForm.copyPaper" clearable style="width: 100px;" @change="validateChange">
                            </el-input>
                            <span style="color: #000000">卷</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="100px" label="毡" prop="mat">
                            <el-input placeholder="" v-model="feedForm.mat" clearable style="width: 100px;" @change="validateChange">
                            </el-input>
                            <span style="color: #000000">盒</span>
                        </el-form-item>
                    </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                <el-form-item label-width="100px" label="保鮮紙" prop="tinFoil">
                    <el-input placeholder="" v-model="feedForm.tinFoil" clearable style="width: 100px;" @change="validateChange">
                    </el-input>
                    <span style="color: #000000">卷</span>
                </el-form-item>
                </el-col>
                <el-col :span="4">
                <el-form-item label-width="100px" label="高木箱" prop="azusa">
                    <el-input placeholder="" v-model="feedForm.azusa" clearable style="width: 100px;" @change="validateChange">
                    </el-input>
                    <span style="color: #000000">個</span>
                </el-form-item>
                </el-col>
                <el-col :span="4">
                <el-form-item label-width="100px" label="矮木箱" prop="shortWood">
                    <el-input placeholder="" v-model="feedForm.shortWood" clearable style="width: 100px;" @change="validateChange">
                    </el-input>
                    <span style="color: #000000">個</span>
                </el-form-item>
                </el-col>
                <el-col :span="4">
                <el-form-item label-width="100px" label="鐵車" prop="IronCar">
                    <el-input placeholder="" v-model="feedForm.IronCar" clearable style="width: 100px;" @change="validateChange">
                    </el-input>
                    <span style="color: #000000">部</span>
                </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="車仔" prop="chelsea">
                        <el-input placeholder="" v-model="feedForm.chelsea" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">部</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="軟紙"  prop="softPaper">
                        <el-input placeholder="" v-model="feedForm.softPaper" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">扎</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="爛紙" prop="lousyPaper">
                        <el-input placeholder="" v-model="feedForm.lousyPaper" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">盒</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="防潮珠" prop="moistureproof">
                        <el-input placeholder="" v-model="feedForm.moistureproof" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">袋</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="電批" prop="electric">
                        <el-input placeholder="" v-model="feedForm.electric" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="叉" prop="fork">
                        <el-input placeholder="" v-model="feedForm.fork" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="150px" label="紙盒(新/舊)">
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="地膠" prop="toGlue">
                        <el-input placeholder="" v-model="feedForm.toGlue" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="膠紙" prop="gummedPaper">
                        <el-input placeholder="" v-model="feedForm.gummedPaper" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="铁笼" prop="cage">
                        <el-input placeholder="" v-model="feedForm.cage" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="夾板(長)" prop="plywood">
                        <el-input placeholder="" v-model="feedForm.plywood" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="大" prop="big">
                        <el-input placeholder="" v-model="feedForm.big" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="中" prop="inthe">
                        <el-input placeholder="" v-model="feedForm.inthe" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="細" prop="fine">
                        <el-input placeholder="" v-model="feedForm.fine" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="Plasma" prop="plasma">
                        <el-input placeholder="" v-model="feedForm.plasma" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col> <el-col :span="4">
                    <el-form-item label-width="100px" label="縐紋紙" prop="crepePaper">
                        <el-input placeholder="" v-model="feedForm.crepePaper" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="平衣" prop="flatClothing">
                        <el-input placeholder="" v-model="feedForm.flatClothing" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="冰箱" prop="refrigerator">
                        <el-input placeholder="" v-model="feedForm.refrigerator" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="黑色橡筋" prop="elastic">
                        <el-input placeholder="" v-model="feedForm.elastic" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">扎</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="紙板" prop="cardboard">
                        <el-input placeholder="" v-model="feedForm.cardboard" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">塊</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="企身" prop="stiff">
                        <el-input placeholder="" v-model="feedForm.stiff" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="梳化套：">
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="床褥套：">
                    </el-form-item>
                </el-col>
                    <el-col :span="4">
                    <el-form-item label-width="100px" label="白水松：">
                    </el-form-item>
                    </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="散箱" prop="bulktank">
                        <el-input placeholder="" v-model="feedForm.bulktank" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col> <el-col :span="4">
                    <el-form-item label-width="100px" label="紙卡板" prop="paperCardBoard">
                        <el-input placeholder="" v-model="feedForm.paperCardBoard" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="3座位" prop="threeSeats">
                        <el-input placeholder="" v-model="feedForm.threeSeats" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="6呎" prop="sixRuler">
                        <el-input placeholder="" v-model="feedForm.sixRuler" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="1吋" prop="oneSmall">
                        <el-input placeholder="" v-model="feedForm.oneSmall" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">袋</span>
                     </el-form-item>
               </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="開木箱工具" prop="tool">
                        <el-input placeholder="" v-model="feedForm.tool" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col> <el-col :span="4">
                    <el-form-item label-width="100px" label="膠(110cm)" prop="glue">
                        <el-input placeholder="" v-model="feedForm.glue" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="2座位" prop="twoSeats">
                        <el-input placeholder="" v-model="feedForm.twoSeats" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="5呎" prop="fiveRuler">
                        <el-input placeholder="" v-model="feedForm.fiveRuler" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="半吋" prop="small">
                        <el-input placeholder="" v-model="feedForm.small" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">袋</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="地台板(長)" prop="lengthFloor">
                        <el-input placeholder="" v-model="feedForm.lengthFloor" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="地台板(短)" prop="shortFloor">
                        <el-input placeholder="" v-model="feedForm.shortFloor" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="1座位" prop="oneSeats">
                        <el-input placeholder="" v-model="feedForm.oneSeats" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="4呎" prop="fourRuler">
                        <el-input placeholder="" v-model="feedForm.fourRuler" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="吊繩" prop="theWire">
                        <el-input placeholder="" v-model="feedForm.theWire" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="滑潤" prop="smooth">
                        <el-input placeholder="" v-model="feedForm.smooth" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="膠(120cm)" prop="oneGlue">
                        <el-input placeholder="" v-model="feedForm.oneGlue" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="">
                        <span style="color: #000000"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="3呎" prop="threeRuler">
                        <el-input placeholder="" v-model="feedForm.threeRuler" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="搬花網" prop="wireMesh">
                        <el-input placeholder="" v-model="feedForm.wireMesh" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="積車" prop="productCar">
                        <el-input placeholder="" v-model="feedForm.productCar" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">部</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="膠紙冚" prop="tape">
                        <el-input placeholder="" v-model="feedForm.tape" clearable style="width: 100px;" @change="validateChange">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                    <el-form-item label-width="100px" label="其他：" prop="other">
                        <el-input placeholder="" v-model="feedForm.other" clearable style="width: 1200px;">
                        </el-input>
                    </el-form-item>
            </el-row>
            <el-row :gutter="0">
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;" @click="feedBackSave">保存</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;" @click="goBack">返回</el-button>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import axios from 'axios'
    import {insertFeedBack} from '../api/api'
    export default {
        data() {

            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                feedForm:{
                    feedDate:"",
                    carNumber:'',
                    title:'',
                    pitPaper:'',  //坑紙
                    newsPaper:'',  //报纸
                    buBu:'',
                    copyPaper:'',
                    mat:'',     //毡
                    tinFoil:'', //保鲜纸
                    azusa:'',
                    shortWood:'',  //矮木
                    IronCar:'',
                    toGlue:'',
                    softPaper:'',
                    lousyPaper:'',
                    moistureproof:'',
                    electric:'',
                    gummedPaper:'',
                    big:'',
                    inthe:'',
                    fine:'',
                    plasma:'',
                    crepePaper:'',
                    flatClothing:'',
                    refrigerator:'',
                    elastic:'',
                    cardboard:'',
                    stiff:'',
                    bulktank:'',
                    paperCardBoard:'',
                    threeSeats:'',
                    twoSeats:'',
                    oneSeats:'',
                    threeRuler:'',
                    fourRuler:'',
                    fiveRuler:'',
                    sixRuler:'',
                    oneSmall:'',
                    small:'',
                    tool:'',
                    glue:'',
                    cage:'',
                    theWire:'',
                    plywood:'',
                    oneGlue:'',
                    wireMesh:'',
                    productCar:'',
                    tape:'',
                    other:'',

                    fork:'',  //叉
                    shortFloor:'', //短木板
                    lengthFloor:'',
                    chelsea:'',//車仔
                    smooth:''   //滑潤
                },
                feedRules:{
                    feedDate:[
                        {required: true, message: '日期不能為空', trigger: 'change' },
                    ],
                    carNumber:[
                        {required: true, message: '車號不能為空', trigger: 'change' },
                    ],
                    title:[
                        {required: true, message: '不能為空', trigger: 'change' },
                    ],
                },
            }
        },
        methods: {
            resetForm(formName){
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            validateChange(ev){
                if(ev!=null && ev!=''){
                    var re=/^[0-9]\d*\.{0,1}\d{0,1}$/;
                    if(!re.test(ev)){
                        this.$message.error("請輸入正確的格式，數字只有1位小數");
                        return false;
                    }
                }
            },
          /*  validateChangeList(ev){
                if(ev!=null && ev!=''){
                    var str = ev.split("/");
                    console.log(str[0]+"==="+str[1]);
                    var re=/^[0-9]\d*\.{0,1}\d{0,1}$/;
                    if(!re.test(str[0]) && !re.test(str[1])){
                        this.$message.error("請輸入正確的格式，數字只有1位小數");
                        return false;
                    }
                }
            },*/
            feedBackSave(){
                this.$refs.feedForm.validate((valid) => {
                        if (valid) {
                            if (this.feedForm.feedDate == '') {
                                this.feedForm.feedDate = 0
                            }
                            var params = Object.assign({}, this.feedForm);
                            params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                            params.status = 0;
                            insertFeedBack(params).then(data => {
                                let {errcode, errmsg} = data.data;
                                if (errcode == 200) {
                                    this.$message.success("保存成功");
                                    this.resetForm("feedForm");
                                    this.$router.push({
                                        name: '回料紙',
                                        params: {str: new Date().getTime()}
                                    })
                                    this.$store.commit("closeTab", 'feedAdd');
                                } else {
                                    this.$message.error("保存失败");
                                }
                            },);
                        }
                });
            },
            goBack(){
                this.$router.push({
                    name:'回料紙',
                    params:{str:new Date().getTime()}
                })
                this.$store.commit("closeTab","feedAdd");
            },
        },
        mounted() {
        },
        activated(){

        },
        computed: {
        }
    }

</script>

<style lang="scss">
    .menu {
        .right {
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }

    .dataListTable .cell {
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/views/FeedBack.vue